/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ id: NonNullable<unknown> }} Vekn_Id_DisplayInputs */



/**
* | output |
* | --- |
* | "ID: {id}" |
*
* @param {Vekn_Id_DisplayInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const vekn_id_display = /** @type {((inputs: Vekn_Id_DisplayInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vekn_Id_DisplayInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`ID : ${i?.id}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`ID: ${i?.id}`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`ID: ${i?.id}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`ID: ${i?.id}`)
	return /** @type {LocalizedString} */ (`ID: ${i?.id}`)
});